export const environment = {
  production: true,
  stage: 'production',
  GTM_ID: 'GTM-5SRCQ2S',
  RECAPTCHA_SITE_KEY: '6LeglqkUAAAAAP33ES7Pe0rxBkkay01IWAuB8NWe',
};
